export const AuthenType = [
  {
    value: 1,
    display: 'SMS',
  },
  {
    value: 2,
    display: 'Authentication App',
  },
];
